import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=2ae2e614"
import script from "./edit.ts?vue&type=script&lang=js&external"
export * from "./edit.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ae2e614')) {
      api.createRecord('2ae2e614', component.options)
    } else {
      api.reload('2ae2e614', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=2ae2e614", function () {
      api.rerender('2ae2e614', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/replicarSelecaoFranquia/edit.vue"
export default component.exports